import { motion } from 'framer-motion'
import React from 'react'
import {TbHandRock} from 'react-icons/tb'

const Msg2 = () => {
  return (
    <motion.div 
    initial={{opacity:0}}
      transition={{duration:0.8, delay:0.2}}
      whileInView={{opacity:1}}
    className="msg2" style={{
        display: "flex",
        gap:"30px",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "white",
        color: "#0d1117",
        margin: "0px 20px",
        borderRadius: "20px",
        transform: "translateY(-200px)"
    }}>
        <motion.h1
        initial={{x:-30, opacity:0}}
        transition={{duration:0.5, delay:0.4}}
        whileInView={{x:0,opacity:1}}
        style={{
            fontSize: "30px",
        }}>Start a project</motion.h1>
        <motion.p 
        initial={{y:30, opacity:0}}
        transition={{duration:0.5, delay:0.4}}
        whileInView={{y:0,opacity:1}}
        className='p' style={{
            width: "350px",
            fontSize: "15px",
            fontWeight: "500"
        }}>Interested in working together? We should queue up a time to chat. I’ll buy the coffee.</motion.p>
        {/* <Link
        to='/project-planner'
        initial={{x:30, opacity:0}}
        transition={{duration:0.5, delay:0.4}}
        whileInView={{x:0,opacity:1}}
        style={{
            textDecoration: "none",
            display: "flex",
            flexDirection: "row",
            gap: "7px",
            border: "2px solid #0d1117",
            padding: "10px 20px",
            borderRadius: "100px"
        }} className='hover'  href=""><TbHandRock/>Let's Do This</Link> */}
        <motion.a
        initial={{x:30, opacity:0}}
        transition={{duration:0.5, delay:0.4}}
        whileInView={{x:0,opacity:1}}
        target="_blank"
        style={{
            textDecoration: "none",
            display: "flex",
            flexDirection: "row",
            gap: "7px",
            border: "2px solid #0d1117",
            padding: "10px 20px",
            borderRadius: "100px"
        }} className='hover'  href="mailto:lexypaul14@gmail.com"><TbHandRock/>Let's Do This</motion.a>
    </motion.div>
  )
}

export default Msg2